module.exports = __webpack_public_path__ + "img/screen-img-02.d005aee9.webp";